import React, { Component } from 'react';
import './App.css';
import single from './images/single.png'
import multi from './images/multi.png'
import multiu from './images/multiu.png'
import sheader from './images/pdf_single_header.png'
import mheader from './images/pdf_multi_header.png'
import muheader from './images/pdf_multiu_header.png'
import { ResponsiveBar } from 'nivo'
import { ResponsiveLine } from 'nivo'
import { PDFExport } from '@progress/kendo-react-pdf'; //savePDF,
import { svgAsPngUri } from 'save-svg-as-png'; //saveSvgAsPng,


 
class App extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef()
    this.questionRef = React.createRef()
    this.state = {
      existingHW:false,
      costChart:true,
      recuringChart:false,
      table:false,
      selectedRow:'Industry',
      q1Clicked:true,
      q2Clicked:false,
      q3Clicked:false,
      q3BClicked:false,
      q4Clicked:false,
      q5Clicked:false,
      q6Clicked:false,
      q7Clicked:false,
      industry:'',
      type:'single',
      users: 0,
      usersCommerical:0,
      doors: 0,
      onPremSites:1,
      onPremSystems:1,
      upTime: "1 hour per year",
      redundant:true,
      itRate:50,
      itRateCB:true,
      itHours:this.props.appData.defaultData.Recurring['IT Labor'].Site,
      itHoursCB:true,
      itPCRate:this.props.appData.defaultData.Fixed['Workstation'],
      wsCheckBox:true,
      outageCB:true,
      onPremWS:1,
      adminHours:0,
      adminHoursCB:false,
      adminRate:0,
      adminRateCB:false,
      admins:1,
      dataCenter:1800,
      DCCheckBox: true,
      outageReseration:this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Single,
      features:[],
      costOnSiteIT:0,
      costOnSiteFixed:0,
      costRecSoftFeeSite: 0,
      cloudCostFixed:0,
      cloudCostVariable:0,
      reduantQuestion:false,
      featuresOther:"",
      barString:"",
      lineString:""


    }
  //functions are binded so they can be called to update state
    this.handleCredUserChange = this.handleCredUserChange.bind(this)
    this.handleWorkStationChange = this.handleWorkStationChange.bind(this)
    this.handleChangeUsers = this.handleChangeUsers.bind(this)
    this.handleChangeDoors = this.handleChangeDoors.bind(this)
    this.handleChangeIndustry = this.handleChangeIndustry.bind(this)
    this.handleChangeUptime = this.handleChangeUptime.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChangeFeatures = this.handleChangeFeatures.bind(this)
    this.updateapps = this.updateapps.bind(this)
    this.updateappm = this.updateappm.bind(this)
    this.updateappmu = this.updateappmu.bind(this)
    this.handleExistingCheckClick = this.handleExistingCheckClick.bind(this)
    

  }

handleOnPremSystems = (e) => {
  let newvalue = e.target.value
  window.sendevent('On Prem Systems',e.target.value,'');
  this.setState({onPremSystems:e.target.value} )
  if(this.state.itHoursCB===true)this.setState({itHoursCB:true, itHours:this.props.appData.defaultData.Recurring['IT Labor'].Site*newvalue})
  
}
handleCredUserChange = (e) => {  //Disabled removed from model - no impact
   //let newvalue = e.target.value
  this.setState({usersCommerical:e.target.value})
  //if(this.state.adminHoursCB===true) this.setState({adminHours:Math.round(parseFloat(newvalue)+parseFloat(this.state.users))} ) 
  //  
}  
handleChangeUsers(e) { //Disabled removed from model - no impact
    //let newvalue = e.target.value
    this.setState({ users: e.target.value } )
    this.setState({ q3BClicked: true })
   // if(this.state.adminHoursCB===true) this.setState({adminHours:Math.round(parseFloat(this.state.usersCommerical)+parseFloat(newvalue))} ) 
    //  
  }

handleWorkStationChange = (e) => {  
  let newvalue = e.target.value
  window.sendevent('On Prem Workstation',newvalue,'');
    this.setState({onPremWS:newvalue})
      if (this.state.wsCheckBox) {this.setState({itPCRate:this.props.appData.defaultData.Fixed['Workstation']*newvalue}) } 
      
  }

  handleDataCenterCheckBox = () => {
 
    if( this.state.DCCheckBox === false ) {
      this.setState({ DCCheckBox:true, dataCenter:this.state.redundant?this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*2*this.state.onPremSystems:this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*this.state.onPremSystems} );
 
    }
    else  {window.sendevent('Data Center Annual Expense','overridden',''); this.setState({DCCheckBox:false, dataCenter:0} ); }

    

  }
 handleRedundantCheckClick = () => {
    if (this.state.redundant) { 
      this.setState({ redundant: false }); 
       if( this.state.DCCheckBox ) { this.setState({ dataCenter:this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*this.state.onPremSystems} ); }
    }
    else {
      window.sendevent('Redundancy','true','');
      this.setState({ redundant: true });
      if( this.state.DCCheckBox ) { this.setState({ dataCenter:this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*2*this.state.onPremSystems} ); }
    } 
    
  }

 handleExistingCheckClick(e){
     if (this.state.existingHW) { 
        this.setState({ 
          existingHW : false, 
          costOnSiteFixed: (parseFloat(this.state.doors)*this.props.appData.defaultData.Fixed['Hardware'])+this.props.appData.defaultData.Fixed['Field Hardware'].Site[this.state.doors]+this.props.appData.defaultData.Fixed['Server Hardware'].Site[this.state.doors]+this.props.appData.defaultData.Fixed['Additional PACs licenses & installation'].Site[this.state.doors],
          cloudCostFixed: (parseFloat(this.state.doors)*this.props.appData.defaultData.Fixed['Hardware'])+this.props.appData.defaultData.Fixed['NRC'].Cloud[this.state.doors]
        }) 
      }
      else { 
        window.sendevent('Has Existing System','true','');
        this.setState({ 
          existingHW : true,
          costOnSiteFixed: this.props.appData.defaultData.Fixed['Field Hardware'].Site[this.state.doors]+this.props.appData.defaultData.Fixed['Server Hardware'].Site[this.state.doors]+this.props.appData.defaultData.Fixed['Additional PACs licenses & installation'].Site[this.state.doors],
          cloudCostFixed:  this.props.appData.defaultData.Fixed['NRC'].Cloud[this.state.doors]
        }) 
      }
      
  
        
  }

  handleChangeFeatures(event) {
    let featuresList=this.state.features;
    if(event.target.checked)featuresList.push(event.target.value)
    else{
      for(var i = featuresList.length - 1; i >= 0; i--) {
        if(featuresList[i] === event.target.value) {
          featuresList.splice(i, 1);
        }
    }
     
    }
    this.setState({ features: featuresList });
  }
  handleChangeUptime(e) {
    let newvalue = e.target.value
    this.setState({ upTime: newvalue });
    if (newvalue==="1 day per year"||newvalue==="1 hour per year"){
      this.setState({ redundant:true } );
    }
    else this.setState({ redundant:false });
    window.sendevent('Downtime',newvalue,'');
  }
  handleChangeDoors(e) {
    let newvalue = e.target.value
          window.sendevent('Door Count',newvalue,'');
    this.setState({ 
      doors: parseFloat(newvalue), 
      cloudCostVariable: this.props.appData.defaultData.Recurring.Subscription.Cloud[newvalue],
      costOnSiteFixed: (this.state.existingHW?0:(parseFloat(newvalue)*this.props.appData.defaultData.Fixed['Hardware']))+this.props.appData.defaultData.Fixed['Field Hardware'].Site[newvalue]+this.props.appData.defaultData.Fixed['Server Hardware'].Site[newvalue]+this.props.appData.defaultData.Fixed['Additional PACs licenses & installation'].Site[newvalue],
      cloudCostFixed: (this.state.existingHW?0:(parseFloat(newvalue)*this.props.appData.defaultData.Fixed['Hardware']))+this.props.appData.defaultData.Fixed['NRC'].Cloud[newvalue],
      q4Clicked: true 
    } );

  }

  handleChangeIndustry(event) {
    this.setState({ industry: event.target.value });
    this.setState({ q2Clicked: true })
  }
  handleSubmit(event) {
    event.preventDefault();
  }
  calcAllCosts(){
    //This is where originaly all the calulations where made
  }
      

  clear(){
    //method to reset the state when type is changed
    this.setState({ costChart:true,
      existingHW:false,
      recuringChart:false,
      table:false,
      selectedRow:'Industry',
      industry:'',
      users: 0,
      usersCommerical:0,
      doors: 0,
      onPremSites:1,
      onPremSystems:1,
      onPremWS:1,
      upTime: "1 hour per year",
      redundant:true,
      q1Clicked:true,
      q2Clicked:false,
      q3Clicked:false,
      q3BClicked:false,
      q4Clicked:false,
      q5Clicked:false,
      q6Clicked:false,
      q7Clicked:false,
      itRate:50,
      itRateCB:true,
      itHours:this.props.appData.defaultData.Recurring['IT Labor'].Site,
      itHoursCB:true,
      itPCRate:this.props.appData.defaultData.Fixed['Workstation'],
      wsCheckBox:true,
      adminHours:0,
      adminHoursCB:false,
      adminRate:0,
      adminRateCB:false,
      admins:1,
      dataCenter:1800,
      DCCheckBox: true,
      features:[],
      costOnSiteIT:0,
      costOnSiteFixed:0,
      costRecSoftFeeSite: 0,
      cloudCostFixed:0,
      cloudCostVariable:0,
      reduantQuestion:false,
      featuresOther: "",
      outageReseration:this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Single
    })
  }
  exportPDF = () => {
    let t = this;
    this.resume.save(function(p) { 
        t.setState({pdf:false}) 
    }); 
   // savePDF(document.getElementById('finalPDF'), { paperSize: 'Letter' })
}

componentDidUpdate(){
  //this is called everytime the the react app detects a change.
  window.checktips();
 
   if(this.state.pdf===true && this.state.lineString !== '' && this.state.barString !== '' ){ 
    //savePDF(document.getElementById('finalPDF'), { paperSize: 'Letter' }) 
    this.exportPDF();
   }
}
componentDidMount() { // this is called from external buttons to set initial type state,
    document.getElementById('sitechoice').addEventListener("click", this.updateapps);
    document.getElementById('sitechoice2').addEventListener("click", this.updateappm);
    document.getElementById('sitechoice3').addEventListener("click", this.updateappmu);
    document.getElementById('tco-report-nav').addEventListener("click", this.tcoreport);
    document.getElementById('mobile-menu-tcor').addEventListener("click", this.tcoreport);
  }

updateapps() {
  this.setState({type:'single'})
  document.getElementById('calculator').style.display = 'block';
  window.sendevent('Single Version','app click','');
}
updateappm() {
  this.setState({type:'multi'})
  document.getElementById('calculator').style.display = 'block';
  window.sendevent('Multi-Site Version','app click','');
}
updateappmu() {
  this.setState({type:'multiu'})
  document.getElementById('calculator').style.display = 'block';
  window.sendevent('Multi-Unit Version','app click','');
}

tcoreport() {
  if(document.getElementById('pdfbutton')) { document.getElementById('pdfbutton').click() }
    else { alert('Please complete the steps below to view a TCO report.') }
           
}

 // grab PNG (note the fun element reference to svg)
 // Need to render graphs and return png uri string
 // Somehow the first graph is still availible when this is first called (good place to start)

 // kinda works for the visable bar graph.  I think we might need to render all three grahaps and then hide them for this method to work for line graph


  getBar() { 
    let t=this;    

    svgAsPngUri(document.getElementsByClassName("pdfbarholderclass")[0]["children"][0]["children"][0]["children"][0], {canvg: window.canvg, encoderOptions:1,scale:3,selectorRemap:s => s.replace(/\.c3 /g, '') }, function(uri) {
     
      if(uri)t.setState({barString:uri})

      return uri
    });
  }
  getLine() { 
    let t=this;    
   
    svgAsPngUri(document.getElementsByClassName("pdfbarholderclass")[0]["children"][1]["children"][0], {canvg: window.canvg, encoderOptions:1, scale:3, selectorRemap:s => s.replace(/\.c3 /g, '')}, function(uri) {

      if(uri)t.setState({lineString:uri})
      return uri
    });
  }
    scrollToMyRef = (x) => {   // run this method to execute scrolling. 
      console.log(x+' | ' + this.questionRef.current.offsetTop + ' - ' + this.chartRef.current.offsetTop)
      if(x===0){ window.scrollTo(0,0) }
        else {
        window.scrollTo({
            top: this.chartRef.current.offsetTop, 
            behavior: "smooth"   // Optional, adds animation
        }) }
    }
  render() {

    //Some calcs here if based on other state values.  This was causing the lag
   // this.props.appData.defaultData.Fixed['Field Hardware'].Site[newvalue]+this.props.appData.defaultData.Fixed['Server Hardware'].Site[newvalue]+this.props.appData.defaultData.Fixed['Additional PACs licenses & installation'].Site[newvalue]
    let ITRedundentVariable= this.state.redundant?0:(this.state.outageReseration*this.state.itRate);
    let RecSoftRedFee = this.state.redundant?(this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Redunednt[this.state.doors]):0; 
    let ITOnSite=  this.state.dataCenter
    +(this.state.adminHours*this.state.adminRate*this.props.appData.defaultData.Recurring['DBA Labor'].Site)
    +(this.state.itHours*this.state.itRate)
    +ITRedundentVariable
    + (this.state.itPCRate); 

    // Added new SAR Software Fee //ADD Door install cost here (removed/seperated out for bar graph)
    let HardwareInstall = this.state.existingHW?0:(this.props.appData.defaultData.Fixed['Hardware']*this.state.doors)
    let NRCtotalSite = Math.round(this.state.doors?HardwareInstall + this.props.appData.defaultData.Fixed['NRC'].Site[this.state.doors]+(this.state.admins*this.props.appData.defaultData.Fixed['System Admin Resources'].Site):0);

    let RecSoftFeeSite=this.state.redundant?0:(this.props.appData.defaultData.Recurring['Software Fees'].Site.Single[this.state.doors]);
    let questionCount=1;
 
    let industries= this.props.appData.defaultData.Industry.map((element) => <option key={element.toString()}>{element}</option>); //

    //console.log(this.props.appData.defaultData.Industry);
    //this.props.appData.defaultData.Industry.forEach( element => {industries.push(<option>{element}</option>);});

    let tcoOnPrem = this.state.doors?(( NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0) ) + ((RecSoftFeeSite+RecSoftRedFee)*4+(ITOnSite*5))):0;
    let tcoBrivo = this.state.doors?((this.state.cloudCostFixed + (this.props.appData.defaultData.Recurring.Subscription.Cloud[this.state.doors]*5) )):0;
    let adminHourTotal = 0 // REMOVED FROM MODEL //this.state.doors? this.state.adminRate === 0 || this.state.adminHours === 0 ? 0 : Math.round((this.state.adminHours*this.state.adminRate*this.props.appData.defaultData.Recurring['DBA Labor'].Site)/this.state.adminRate) : 0;


    //If pdf button pressed <button onClick={ savePDF(document.getElementById('finalPDF'), { paperSize: 'Letter' }) }>download save method</button>
 // swap header graphic based on this.state.type [ "single" 'multi' or 'multiu' ]
    if(this.state.pdf===true){
      let pdfheader = sheader;
      if(this.state.type==='multiu') ( pdfheader = muheader ); else if(this.state.type==='multi')( pdfheader = mheader ); 
       
      return (

        <form onSubmit={this.handleSubmit}>
         <div className="loading">Creating Report&#8230;</div>
        <div>

        <button onClick={this.exportPDF}>download</button>
        <button onClick={(e) =>{ this.setState({pdf:false})}}>back to calculator</button>
        <PDFExport  paperSize={'Letter'}
                    fileName="Brivo_TCO_Calc_Report.pdf"
                    title= {"CLOUD VS. ON-PREM TOTAL COST OF OWNERSHIP (TCO) REPORT -" + this.state.type.toUpperCase() }
                    subject=""
                    keywords=""
                    ref={(r) => this.resume = r}
                    avoidLinks="true"> 

    <div className="PDFholder" id="finalPDF">
        <div style={{
            height: 792,
            width: 612,
            padding: 'none',
            backgroundColor: 'white',
            boxShadow: '5px 5px 5px black',
            margin: 'auto',
            overflowX: 'hidden',
            overflowY: 'hidden',
            fontSize : '12px'
            }}>
                 <img
                    alt="TCO header"
                    src={pdfheader}
                    height="282px"
                />
        <div className='row PDFContent'>
          <div className='col-6'>
                <div className="PDFRow">
                    <div className="pdfseltitle">
                   {questionCount++}) {this.props.appData.text.Q1.Title}: {this.state.industry}
                  </div>
                 
                </div>
                <div className="PDFRow">
                    <div className="pdfseltitle">
                      <div>{questionCount++}) {this.props.appData.text.Q2.Title}{this.state.type!=='multiu' && <span>: {this.state.users}</span> }</div>
                      {this.state.type==='multiu' && <div>{this.props.appData.text.Q2[this.state.type].QuestionA}: {this.state.users}</div> }
                      {this.state.type==='multiu' && <div>{this.props.appData.text.Q2[this.state.type].Question2}: {this.state.usersCommerical}</div> }
                    </div>
                 
                </div>
               
                <div className="PDFRow">
                    <div className="pdfseltitle"> 
                      <div>{questionCount++}) {this.props.appData.text.Q3B.Title}</div>
                     {this.state.type!=='single' &&   <div>{this.props.appData.text.Q3B[this.state.type].Question1}: {this.state.onPremSites}</div> }
                      <div>{this.props.appData.text.Q3B[this.state.type].Question2}: {this.state.onPremSystems}</div>
                      <div>{this.props.appData.text.Q3B[this.state.type].Question3}: {this.state.onPremWS}</div>
                    </div>
                  </div>
                 
                <div className="PDFRow">
                    <div className="pdfseltitle">
                    {questionCount++}) {this.props.appData.text.Q3.Title}: {this.state.doors}
                    {this.state.existingHW===true && <div>Existing System: Reuse existing door hardware.</div> }
                    {this.state.existingHW===false && <div>No Existing system: Include door hardware.</div> }
                  </div>
                </div>
                <div className="PDFRow">
                    <div className="pdfseltitle">
                    <div>{questionCount++}) {this.props.appData.text.Q4.Title}</div>
                    <div>Lowest acceptable downtime: {this.state.upTime} </div>
                    <div>Redundant Solution: {this.state.redundant ? 'Yes':'No'}</div>
                  </div>
                </div>

                <div className="PDFRow">
                    <div className="pdfseltitle">
                    <div>{questionCount++}) {this.props.appData.text.Q5.Title}: {this.state.admins} </div>
                  </div>
                </div>
        
                <div className="PDFRow">
                    <div className="pdfseltitle">
                    <div>{questionCount++}) IT Resources Annual Recurring Expense*</div>
                    <div>Server maintenance total expense ${Math.round(this.state.itHours * this.state.itRate)}<br/>
                     {this.state.itHours} hours @ ${this.state.itRate} per hr</div>
                     <div>Workstation annual support expense: ${this.state.itPCRate} </div>
                    <div>Data center annual expense: ${this.state.dataCenter}</div>
                    {!this.state.redundant && <div>Outage restoration**: {this.state.outageReseration} hours</div> }
                  </div>
                </div>
                <p className="small">*Represents an incurred expense or opportunity cost that results in freeing up IT/Admin resources</p>
                {!this.state.redundant && <p className="small">** Incurred if redundancy not selected</p>}
            </div>
          <div className='col-6'>
            <div className="charttitle">TCO COST: On-Prem vs. Brivo Cloud</div>
                       <div className="row"> 
              <div className="col-1"></div>
              <div className="col-5 charthead"> Non-Recurring<br/> Costs (NRC)</div>
              
              <div className="col-5 charthead"> Annual Recurring<br/> Costs (RC)</div>
              <div className="col-1"></div>
            </div>
            <div class="chartLine" id="mybarchart"></div>
            <img  // Bar CHART
              className = "pdfbarchartpng"
              alt = "TCO Bar Chart"
              src={this.state.barString}
                    height="400px"
                />

                <div className="charttitle">TCO SAVIINGS: On-Prem vs. Brivo Cloud</div>
                <div className='lowertco'>{Math.round(((tcoOnPrem - tcoBrivo)/tcoOnPrem)*100)}% Lower TCO </div> 
                <img //Line CHART
                    className = "pdflinechartpng"
                    alt = "TCO Line Chart"
                    src={this.state.lineString}
                    height="400px"
                />

          </div>
        </div>
           </div>
        </div>
          
</PDFExport>

</div> </form>
      )
    }
    //This is the main page The 3 types follewed by the question divs and the graphs are  last
    return ( 
     


<form onSubmit={this.handleSubmit}>
<div className='respButCharts' onClick={() =>{ this.scrollToMyRef(1) }}>See Graphs</div>
<div className='respButInputs' onClick={() =>{ this.scrollToMyRef(0)  }}>Review Questions</div>
 <div className=''>
  <div className='row'>
    <div ref={this.questionRef} className='col-lg-6 questionholder'>
        <div className='row'>
            <div className='col-md-8'>
              <div className='row'>
                <div className={this.state.type==='single'?'col-4 select selectedType':'select col-4'} onClick={() => {
                  if(this.state.type!=="single"&&window.confirm('Changing type will Clear your choices')){
                    this.setState({type:'single'})
                    document.tco='single'
                    this.clear()
                    window.sendevent('Site Choice APP','Single Version','');
                  } 
                  }}>
                    <img alt='' height='64px' src={single}/> <br/>
                    Single-Site
                </div>
                <div className={this.state.type==='multi'?'col-4 select selectedType':'select col-4'} onClick={() => {
                  if(this.state.type!=="multi"&&window.confirm('Changing type will Clear your choices')){
                    this.setState({type:'multi'})
                    this.clear()
                    window.sendevent('Site Choice APP','Multi-Site Version','');
                  } 
                  }}>
                    <img alt='' height='64px' src={multi}/> <br/>
                    Multi-Site
                    </div>
                <div className={this.state.type==='multiu'?'col-4 select selectedType':'select col-4'} onClick={() => {
                  if(this.state.type!=="multiu"&&window.confirm('Changing type will Clear your choices')){
                    this.setState({type:'multiu'})
                    this.clear()
                    window.sendevent('Site Choice APP','Multi-Unit Version','');
                  } 
                  }}>
                    <img alt='' height='64px' src={multiu}/> <br/>
                    Multi-Unit
                </div>
              </div>
              <div className="optionrowswrap">
            <div className={this.state.selectedRow==='Industry'?'selectedRow':(this.state.q1Clicked?'questionSection':'incompleteRow')}>
            <div className="seltitle" onClick={() =>{ 
                  this.setState({q1Clicked:true});
                  this.setState({selectedRow:this.state.selectedRow!=='Industry'?'Industry':''})
              }}>
               {questionCount++} {this.props.appData.text.Q1.Title}
              </div>
              {this.state.selectedRow==='Industry' &&
              <div>{/*this.props.appData.text.Q1[this.state.type].Question*/}



                <select value={this.state.industry} onChange={this.handleChangeIndustry} disabled = {false}>
                  {industries}
                </select>
              </div>}
            </div>
 
            <div className={this.state.selectedRow==='Users'?'selectedRow':(this.state.q2Clicked?'questionSection':'incompleteRow')}>
            <div className="seltitle" onClick={() =>{ 
                  this.setState({q2Clicked:true});
                //  this.setState({ q3BClicked: true }) // when click in the box
                  this.setState({selectedRow:this.state.selectedRow!=='Users'?'Users':''})
            }}>
              {questionCount++} {this.props.appData.text.Q2.Title}
              </div>

            {this.state.selectedRow==='Users' && <div className="row">
                      <div className="col-8">{this.props.appData.text.Q2[this.state.type].Question}</div><br/><br/>
              {this.state.type==='multiu' && <div className="col-8">{this.props.appData.text.Q2[this.state.type].QuestionA}</div> }
              {this.state.type==='multiu' ? (<div className="col-4"><input min="0" step="50" type="number" value={this.state.users} onChange={this.handleChangeUsers} disabled = {false}></input> </div>) :
              (<div className="col-4"><input min="0" step="50" type="number" value={this.state.users} onChange={this.handleChangeUsers} disabled = {false}></input></div>)}
              </div>}
            {this.state.selectedRow==='Users' &&this.state.type==='multiu'&&
              <div className="row">
                      <div className="col-8">{this.props.appData.text.Q2[this.state.type].Question2}</div>

               <div className="col-4"> <input min="0" step="50"  type="number" value={this.state.usersCommerical} onChange={ this.handleCredUserChange } disabled = {false}></input>
              </div></div>
            }
            <div className="hints">
            {this.state.selectedRow==='Users' &&<div className="hintContainerResp">
                  <h3>Helpful Tip</h3> 
                  Some on premise solution providers include additional fees per user for mobile credentials or other charges. <br/><br/>
                  There is <strong>NO</strong> per user license fee with Brivo.
              </div>}</div>
            </div>
              <div className={this.state.selectedRow==='OnPrem'?'selectedRow':(this.state.q3BClicked?'questionSection':'incompleteRow')}> 
              <div className="seltitle" onClick={() =>{ 
                  this.setState({q3BClicked:true});
                  this.setState({ q3Clicked: true })
                  this.setState({selectedRow:this.state.selectedRow!=='OnPrem'?'OnPrem':''})
              }}>
                {questionCount++} {this.props.appData.text.Q3B.Title}
                </div>
              {this.state.selectedRow==='OnPrem' &&
                <React.Fragment>
                  {this.state.type!=="single"&&<div className="row">
                      <div className="col-8">{this.props.appData.text.Q3B[this.state.type].Question1}</div>

                    <div className="col-4"> <input min="0" type="number" value={this.state.onPremSites} onChange={(e) =>{ window.sendevent('On Prem Sites',e.target.value,''); this.setState({onPremSites:e.target.value} )}} disabled = {false}></input>
                  </div></div>}
                  <div className="row">
                      <div className="col-8">{this.props.appData.text.Q3B[this.state.type].Question2}</div>
                    <div className="col-4"><input min="0" type="number" value={this.state.onPremSystems} onChange={ this.handleOnPremSystems } disabled = {false}></input>
                  </div></div>
                    <div className="row">
                      <div className="col-8">{this.props.appData.text.Q3B[this.state.type].Question3}</div>
                    <div className="col-4"><input min="0" type="number" value={this.state.onPremWS} onChange={ this.handleWorkStationChange } disabled = {false}></input></div>
                  

                  </div>
               </React.Fragment>
              }
              <div className="hints">
              {this.state.selectedRow==='OnPrem' &&<div className="hintContainerResp">
                  <h3>Helpful Tip</h3> 
                  64% of physical security system are still locally managed via on-prem solutions that will require on-site IT support*.<br/><br/>
                  {this.state.type==='single'? "Single location systems typically include a server or one or more dedicated workstations.":"On-prem servers and workstations require additional IT support. See assumptions."}

              </div>}</div>
           
              </div>
 
              <div className={this.state.selectedRow==='Doors'?'selectedRow':(this.state.q3Clicked?'questionSection':'incompleteRow')}> 
              <div className="seltitle" onClick={() =>{ 
                  this.setState({q3Clicked:true});
                  this.setState({selectedRow:this.state.selectedRow!=='Doors'?'Doors':''})
              }}>
              {questionCount++} {this.props.appData.text.Q3.Title}
              </div>
                {this.state.selectedRow==='Doors' && <React.Fragment>
                <div>{/*this.props.appData.text.Q3[this.state.type].Question*/}
                  <select value={this.state.doors} onChange={this.handleChangeDoors} disabled = {false}>
                    <option value="0">Select a door count option</option>
                    <option value="5">5</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="60">60</option>
                    <option value="120">120</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    </select>
                  </div>
                  <div className="col-12">
                  <br/>
                  If you have an existing on-prem system you may be able to reuse existing door hardware including locks, readers,  and wiring that are common to both solutions. 
                  Check "Existing System" to exclude these costs from TCO calculations. <br/><br/>

                     <label className="redcheckbox">
                    Existing System
                    <input
                      disabled = {false}
                      name="Existing"
                      type="checkbox"
                      checked={this.state.existingHW}
                      onChange={this.handleExistingCheckClick}
                    />
                  </label><br/></div>
</React.Fragment>

                }
                 <div className="hints">
              {this.state.selectedRow==='Doors' &&<div className="hintContainerResp">
                 <h3>Helpful Tip</h3> 
                  Doors/Entryways include: gates, garages, elevators, perimeter & interior doors. <br/><br/>
                  
                  See assumptions for details on all non-recurring and recurring expenses displayed in graphs after selecting appropriate door count. <br/><br/>

                  Please contact your Brivo Sales Partner for a more specific estimate. <br/><br/>
                  
              </div>}</div>
              </div>
              <div className={this.state.selectedRow==='UpTime'?'selectedRow':(this.state.q4Clicked?'questionSection':'incompleteRow')}> 
              <div className="seltitle" onClick={() =>{
                 this.setState({q4Clicked:true});
                 this.setState({q5Clicked:true});
                 this.setState({reduantQuestion:true})
                 this.setState({selectedRow:this.state.selectedRow!=='UpTime'?'UpTime':''})
                }}>
                {questionCount++} {this.props.appData.text.Q4.Title}
              </div>
              {this.state.selectedRow==='UpTime' &&
                <React.Fragment>
                <div className="row">
                  <div className="col-7">{this.props.appData.text.Q4[this.state.type].Question}</div>
                    
                      <div className="col-5">  <select className="suptime" value={this.state.upTime} onChange={this.handleChangeUptime} disabled = {false}>
                     <option>1 hour per year</option> 
                     <option>1 day per year</option>
                     <option>2 days per year</option>
                     <option>7 days per year</option>
                      
                      
                      
                    </select></div>
                    <div className="col-12">
                     <label className="redcheckbox">
                    Add Redundancy
                    <input
                      disabled = {false}
                      name="Redundant"
                      type="checkbox"
                      checked={this.state.redundant}
                      onChange={this.handleRedundantCheckClick}
                    />
                  </label></div>
                  </div>
                 
                  <div className="viewwith">View costs with/ without redundancy</div>
               </React.Fragment>
              }
                <div className="hints">
              {this.state.selectedRow==='UpTime' &&<div className="hintContainerResp">
                 <h3>Helpful Tip</h3> 
                  A high availability, redundant solution is recommended if:<br/><br/>
                    <ul className="listUpTime">
                    <li>You selected 1 day or less of downtime per year  </li><br/>
                    <li>Your organization requires redundancy  </li>
                    </ul>
                    <br/>
                    <p className="helpfulTipP">Redundancy adds license fees and additional hardware and data center expense while eliminating default outage restoration fees. See <a href="#sla" className="showAssumption">assumptions</a> for Redundancy, Data Center and SLA Downtime impact.
                    </p>
                  
              </div>}</div>
              </div>
              <div className={this.state.selectedRow==='Admin'?'selectedRow':(this.state.q5Clicked?'questionSection':'incompleteRow')}> 
              <div className="seltitle" onClick={() =>{
                this.setState({q5Clicked:true});
                this.setState({q6Clicked:true});
                this.setState({selectedRow:this.state.selectedRow!=='Admin'?'Admin':''})
              }
              }>
                {questionCount++} {this.props.appData.text.Q5.Title}
                </div>
              {this.state.selectedRow==='Admin' &&
                <React.Fragment>
                <div className="row">
                  <div className="col-8">{this.props.appData.text.Q5[this.state.type].Question} </div>
                  <div className="col-4"><input min="0" type="number" value={this.state.admins} onChange={(e) => this.setState({admins:e.target.value})} disabled = {false}></input></div>
                </div>
                 </React.Fragment>
              }
              {this.state.selectedRow==='REMOVED' &&  // This has been removed from model but may be turned back on later so moved out of Admin section for now
                <React.Fragment>
                  <div className="row">
                  <div className="col-8">Manual credential updates/year</div>
                  <div className="col-4">  <input min="0" step="50" type="number" value={this.state.adminHours} onChange={(e) => { this.setState({adminHoursCB:false,adminHours:(e.target.value)})}} disabled = {false}></input></div>
                  
                  <div className="col-12"><label>
                    Use default
                    <input
                      disabled = {false}
                      name="adminDefult"
                      type="checkbox"
                      checked={this.state.adminHoursCB}//Math.round(this.props.appData.defaultData.Recurring['DBA Labor'].Site*this.state.users)}
                      onChange={(e) =>{
                        if(this.state.adminHoursCB===false)this.setState({adminHoursCB:true,adminHours:Math.round(parseFloat(this.state.usersCommerical)+parseFloat(this.state.users))} )  
                        else  this.setState({adminHoursCB:false,adminHours:0} )
                    }}/>
                  </label></div></div>
                   <div className="row">
                  <div className="col-8">Admin hourly rate</div>
                   <div className="col-4"> <input min="0" step="10" type="number" value={this.state.adminRate} onChange={(e) =>{ this.setState({adminRateCB:false,adminRate:e.target.value} )}} disabled = {false}></input>
                  </div>
                  <div className="col-12"><label>
                      Use default&nbsp;
                      <input
                        disabled = {false}
                        name="adminDefultRate"
                        type="checkbox"
                        checked={this.state.adminRateCB}
                        onChange={() =>{
                          if(this.state.adminRateCB===false) this.setState({adminRateCB:true,adminRate:40},() => {} )
                          else  this.setState({adminRateCB:false,adminRate:0} )
                        }} />
                    </label> 
                    </div>
                    </div>
                </React.Fragment>
              }
               <div className="hints">
              {this.state.selectedRow==='Admin' &&<div className="hintContainerResp">
                  <h3>Helpful Tip</h3> 
                    Model includes a non-recurring license fee per admin for on-prem.<br/>{/*this.props.appData.text.Q5[this.state.type].Hint*/}
                    <br/>
                    There is no per seat System Admin license fee with Brivo.<br/>
                  
              </div>}</div>
              </div>
 
              <div className={this.state.selectedRow==='IT'?'selectedRow':(this.state.q6Clicked?'questionSection':'incompleteRow')}> 
              <div className="seltitle" onClick={() =>{ 
                //this.setState({q6Clicked:true});
                this.setState({selectedRow:this.state.selectedRow!=='IT'?'IT':''})
              }}>
                {questionCount++} {this.props.appData.text.Q6.Title}
                </div>
              {this.state.selectedRow==='IT' &&
                <React.Fragment>
                  <div>{this.props.appData.text.Q6[this.state.type].Question}</div><br/>
                  <div className="row">
                  <div className="col-8">IT hours per year</div>
                  <div className="col-4"> <input min="0" type="number" value={this.state.itHours} onChange={(e) =>{window.sendevent('IT hours per year','overridden',''); this.setState({itHoursCB:false, itHours:e.target.value} )}} disabled = {false}></input>
                  </div>
                  <div className="col-12">
                  <label>
                    Use default
                    <input
                      disabled = {false}
                      name="adminDefult"
                      type="checkbox"
                      checked={this.state.itHoursCB} //this.state.itHours===(this.props.appData.defaultData.Recurring['IT Labor'].Site*this.state.onPremSystems)}
                      onChange={(e) =>{
                        if(this.state.itHoursCB===false){
                          this.setState({itHoursCB:true, itHours:this.props.appData.defaultData.Recurring['IT Labor'].Site*this.state.onPremSystems});                   
                        }
                        else  { window.sendevent('IT hours per year','overridden',''); this.setState({itHoursCB:false, itHours:0} ); }
                      }} />
                    </label>
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-8">IT hourly rate</div>
                     <div className="col-4"> <input min="0" step="10" type="number" value={this.state.itRate} onChange={(e) =>{this.setState({itRate:e.target.value,itRateCB:false} )}} disabled = {false}></input>
                    </div>
                    <div className="col-12">
                    <label>
                      Use default&nbsp;
                      <input
                        disabled = {false}
                        name="itRate"
                        type="checkbox"
                        checked={this.state.itRateCB}
                        onChange={(e) =>{
                          if(this.state.itRateCB===false)
                          this.setState({itRate:50,itRateCB:true})
                          else  this.setState({itRate:0,itRateCB:false})
                        }} />
                      </label></div></div>
                    
                     <div className="row">
                      <div className="col-8">Workstation annual support expense</div>
                      <div className="col-4"><input min="0" type="number" value={this.state.itPCRate} onChange={(e) =>{window.sendevent('Workstation Ann. Support Expense','overridden',''); this.setState({wsCheckBox:false,itPCRate:parseFloat(e.target.value)} )}} disabled = {false}></input>
                    </div>
                    <div className="col-12">
                    <label>
                      Use default
                      <input
                        disabled = {false}
                        name="itPCRateBox"
                        type="checkbox"
                        checked={this.state.wsCheckBox}
                        onChange={(e) =>{
                          if((this.state.wsCheckBox===false)){
                          this.setState({wsCheckBox:true, itPCRate:this.props.appData.defaultData.Fixed['Workstation']*this.state.onPremWS} );

                        }
                          else  { window.sendevent('Workstation Ann. Support Expense','overridden',''); this.setState({wsCheckBox:false, itPCRate:0} );}
                        }} />
                      </label></div></div> 
                      <div className="row">
                      <div className="col-8">Data center annual expense<br/> </div>
                      <div className="col-4"><input min="0" type="number"  value={this.state.dataCenter} onChange={(e) =>{window.sendevent('Data Center Annual Expense','overridden','');this.setState({dataCenter:parseFloat(e.target.value),DCCheckBox:false} )}} disabled = {false}></input>
                      </div>
                      <div className="col-12">
                      <label>
                        Use default
                       
                        <input
                          disabled = {false}
                          name="DCRate"
                          type="checkbox"
                          checked={this.state.DCCheckBox} //this.state.dataCenter===(this.state.redundant?this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*2*this.state.onPremSystems:this.props.appData.defaultData.Recurring['Data Center Overhead'].Site*this.state.onPremSystems)}
                          onChange={this.handleDataCenterCheckBox} />
                          </label></div>
                          <span className="viewwith">Doubled if redundancy selected</span>
                          </div>
                        {!this.state.redundant&&<div className="row">
                      <div className="col-8">Outage restoration IT hours per year</div>
                        <div className="col-4"> 
                        <input min="0" type="number" value={this.state.outageReseration} onChange={(e) =>{this.setState({outageReseration:parseFloat(e.target.value), outageCB:false} ) } } 
                          disabled = {false}>
                        </input>
                      </div>
                      <div className="col-12"><label>
                        Use default
                        <input
                          disabled = {false}
                          name="outageDefultRate"
                          type="checkbox"
                          checked={this.state.outageCB}
                          onChange={(e) =>{ 
                            if(this.state.outageCB===false)
                            this.setState({outageReseration:(this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Single*this.state.onPremSystems),outageCB:true})
                            else  this.setState({outageReseration:0,outageCB:false} ); 
                        }} />
                        </label></div></div>}
                  </React.Fragment>
              }
              <div className="hints">
              {this.state.selectedRow==='IT' &&<div className="hintContainerResp">
                  <h3>Helpful Tip</h3> 
              On-prem system maintenance includes patches/upgrades, operation, backup and tech support. <br/><br/>
              Use $75 to $150/hour for contractors<br/>
              <br/>
              Server energy and operating expense may account for as much as 85% of total data center expenses.<br/>
              <br/>
              Data center default values display expense impact of supporting redundant and non-redundant on-prem servers.
              <br/><br/>
              See Recurring Expense <a href="#manual" className="showAssumption">assumptions</a> for more details. 
              
                  
              </div>}</div>
             </div>
{/* 
              <div className={this.state.selectedRow==='Features'?'selectedRow':(this.state.q7Clicked?'questionSection':'incompleteRow')}> <div className="seltitle" onClick={() =>{ 
                this.setState({q7Clicked:true});
                this.setState({selectedRow:this.state.selectedRow!=='Features'?'Features':''})
              }}>
                {questionCount++} {this.props.appData.text.Q7.Title}
                </div>
              {this.state.selectedRow==='Features' &&
                <React.Fragment>
                  <div>{this.props.appData.text.Q7[this.state.type].Question}</div>
                  <div>
                    <input type='checkbox' value='Mobile credential' onChange={this.handleChangeFeatures} disabled = {false}/>  
                    <label>Mobile credential & admin</label>
                  </div>
                  <div>
                    <input type='checkbox' value='Unlimited # of readers & cameras' onChange={this.handleChangeFeatures} disabled = {false}/>  
                    <label>Unlimited # of readers & cameras</label>
                  </div>
                  <div>
                    <input type='checkbox' value='Application integration/ APIs' onChange={this.handleChangeFeatures} disabled = {false}/>  
                    <label>Application integration/ APIs</label>
                  </div>
                  <div>
                    <input type='checkbox' value='Wireless door locks' onChange={this.handleChangeFeatures} disabled = {false}/>  
                    <label>Wireless door locks</label>
                  </div>
                  <div>
                    <input type='checkbox' value='Cloud-based Identity management (IAM)' onChange={this.handleChangeFeatures} disabled = {false}/>  
                    <label>Cloud-based Identity management (IAM)</label>
                  </div>
                  <div> <label>Other:</label>
                    <input type='text' value={this.state.featuresOther} onChange={this.handleChangeFeatures} disabled = {false}/>  
                   
                  </div>  
               </React.Fragment>
              }
            </div>
          */ }
            </div>
 
          </div>
         
        <div className='hints col-md-4'>
           {this.state.selectedRow==="Industry"&&<div className="hintContainer"> {this.props.appData.text.Q1[this.state.type].Hint}</div>}
           {this.state.selectedRow==="Users"&&<div className="hintContainer">
                  <h3>Helpful Tip</h3> 
                  Some on premise solution providers include additional fees per user for mobile credentials or other charges. <br/><br/>
                  There is <strong>NO</strong> per user license fee with Brivo.
              </div>}
            {this.state.selectedRow==="Doors"&&<div className="hintContainer">
                  <h3>Helpful Tip</h3> 
                  Doors/Entryways include: gates, garages, elevators, perimeter & interior doors. <br/><br/>
                  
                  See assumptions for details on all non-recurring and recurring expenses displayed in graphs after selecting appropriate door count. <br/><br/>

                  Please contact your Brivo Sales Partner for a more specific estimate. <br/><br/>
                  
            </div>}
            {this.state.selectedRow==="OnPrem"&&<div className="hintContainer">
                  <h3>Helpful Tip</h3> 
                  64% of physical security system are still locally managed via on-prem solutions that will require on-site IT support*.<br/><br/>
                  {this.state.type==='single'? "Single location systems typically include a server or one or more dedicated workstations.":"On-prem servers and workstations require additional IT support. See assumptions."}

            </div>}
            {this.state.selectedRow==="UpTime"&&<div className="hintContainer">
                    <h3>Helpful Tip</h3> 
                    A high availability, redundant solution is recommended if:<br/><br/>
                    <ul className="listUpTime">
                    <li>You selected 1 day or less of downtime per year  </li><br/>
                    <li>Your organization requires redundancy  </li>
                    </ul>
                    <br/>
                    <p className="helpfulTipP">Redundancy adds license fees and additional hardware and data center expense while eliminating default outage restoration fees. See <a href="#sla" className="showAssumption">assumptions</a> for Redundancy, Data Center and SLA Downtime impact.
                    </p>
                    </div>}
            {this.state.selectedRow==="Admin"&&<div className="hintContainer">
                    <h3>Helpful Tip</h3> 
                    Model includes a non-recurring license fee per admin for on-prem.<br/>{/*this.props.appData.text.Q5[this.state.type].Hint*/}
                    <br/>
                    There is no per seat System Admin license fee with Brivo.<br/>

                    </div>}
            {this.state.selectedRow==="IT"&&<div className="hintContainer">

              <h3>Helpful Tip</h3> 
              On-prem system maintenance includes patches/upgrades, operation, backup and tech support. <br/><br/>
              Use $75 to $150/hour for contractors<br/>
              <br/>
              Server energy and operating expense may account for as much as 85% of total data center expenses.<br/>
              <br/>
              Data center default values display expense impact of supporting redundant and non-redundant on-prem servers.
              <br/><br/>
              See Recurring Expense <a href="#manual" className="showAssumption">assumptions</a> for more details. 
              

              </div>}
            {this.state.selectedRow==="Features"&&<div className="hintContainer"><h3>Helpful Tip</h3> {this.props.appData.text.Q7[this.state.type].Hint}</div>}
         </div>
      </div>
  <div className='resetButtonHolder'>    
    <button className='resetButton' onClick={() => { if(window.confirm('Reset your choices?')){ this.clear() }  }}>Reset</button>
    </div>
 </div>
<div ref={this.chartRef} className='col-lg-6 chartholder' id="chartArea">
          <div className='generatechart col-12'>
            <button className={this.state.costChart === true ? 'active' : 'nonactive'} onClick={(e) =>{
              this.setState({costChart:true})
              this.setState({recuringChart:false})
              this.setState({table:false})
              window.sendevent('Cost Graph','click','');
            }}>TCO Cost</button>
 
             <button className={this.state.recuringChart === true ? 'active' : 'nonactive'} onClick={(e) =>{
              this.setState({costChart:false})
              this.setState({recuringChart:true})
              this.setState({table:false})
              window.sendevent('TCO Savings Graph','click','');
            }}>TCO Savings</button>
            <button className={this.state.table === true ? 'active' : 'nonactive'} onClick={(e) =>{
              this.setState({costChart:false})
              this.setState({recuringChart:false})
              this.setState({table:true})
              window.sendevent('IT Admin Impact Chart','click','');
            }}>IT/Admin Impact</button>
 
            {this.state.table&&<table>
            <tbody>
                  <tr>
    
            <th colSpan="5" className='tabletopHeader'>
            IT/Admin Expense & Productivity Impact
            </th>
            </tr>
            <tr className='tableheads'>
            <th>Expense Category</th>
            <th>Cost Type</th>
            <th>Ann. Expense</th>
            <th>Hours/ Year</th>
            <th>Hourly Rate</th>
            </tr>

                  <tr>
                    <th>Server Maintenance, Operations and Tech Support</th>
                    <th>IT Labor</th>
                    <th>${Math.round(this.state.itHours*this.state.itRate)}</th> 
                    <th>{Math.round(this.state.itHours)}</th> 
                    <th>${this.state.itRate}</th> 
                  </tr>
          
                   <tr>
                    <th>Workstation/PC Tech Support</th>
                    <th>IT Labor & Energy Exp.</th>
                    <th>${Math.round(this.state.itPCRate)}</th> 
                    <th></th> 
                    <th></th> 
                  </tr>
         
                  <tr>
                    <th>Data Center Overhead</th>
                    <th>Pro-Rated Allocation</th>
                    <th>${this.state.dataCenter}</th> 
                    <th></th> 
                    <th></th> 
                  </tr>
           {this.state.redundant===false&& <React.Fragment>     
                  <tr>
                    <th>Outage restoration</th>
                    <th>IT Labor</th>
                    <th>${this.state.outageReseration*this.state.itRate}</th> 
                    <th>{this.state.outageReseration}</th> 
                    <th>${this.state.itRate}</th> 
                  </tr>
            </React.Fragment> }
                   <tr>
                    <th colSpan="1">Subtotals</th>
                    <th colSpan="1"></th>
                    
                    <th colSpan="1">
                    ${
                    (Math.round(this.state.adminHours*this.state.adminRate*this.props.appData.defaultData.Recurring['DBA Labor'].Site)) +
                    (Math.round(this.state.itHours*this.state.itRate)) +
                    (Math.round(this.state.itPCRate)) + 
                    (this.state.dataCenter) + 
                    (this.state.redundant===false?(this.state.outageReseration*this.state.itRate):0)}

                    </th> 

                    <th colSpan="1">{this.state.redundant===true ? adminHourTotal+this.state.itHours : this.state.outageReseration+adminHourTotal+this.state.itHours }</th>
                    <th colSpan="1"></th>
                  </tr>
                  </tbody>
            </table>

          }

            {this.state.costChart&&<div className='chartContainer'>
            <h6 className="charttitle">On-Prem vs. Brivo Cloud</h6>
           <div className="row"> 
              <div className="col-1">&nbsp;</div>
              <div className="col-5 charthead"> <h6>Non-Recurring<br/> Costs (NRC)</h6></div>
              
              <div className="col-5 charthead"> <h6>Annual Recurring<br/> Costs (RC)</h6></div>
              <div className="col-1">&nbsp;</div>
            </div>
          <div className='barChart'>
          <div className='chartLine' id='mybarchart'></div>
          <ResponsiveBar 

        data={[

          {

          "type": "On-Prem NRC",
          "Hardware Software Install": this.state.doors===0?0:(NRCtotalSite-HardwareInstall),
          "Hardware Software InstallColor": "#F16521",
          "Doors+ Hardware Installation":this.state.doors===0? 0:HardwareInstall,
          "Doors+ Hardware InstallationColor": "#999999",
          "Redundancy option":Math.round(this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0),
          "Redundancy optionColor": "#BFBFBF"

        },
        {
          "type": "Brivo NRC",
          "Brivo Hardware Software Install": Math.round(this.state.doors?this.props.appData.defaultData.Fixed['NRC'].Cloud[this.state.doors]:0),
          "Brivo Hardware Software InstallColor": "#739CD2",
          "Doors+ Hardware Installation": this.state.doors===0? 0:HardwareInstall,
          "Doors+ Hardware InstallationColor": "#999999"
       
        },
        {
          "type": "On-Prem RC",
          "Subscription fees": 0,
          "License & other fees": this.state.doors===0? 0: Math.round(RecSoftFeeSite),
          "License & other feesColor": "#7AC142",
          "IT & Admin Labor/Data Center":this.state.doors===0? 0:  Math.round(ITOnSite), //this.state.redundant?(this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Redunednt[this.state.doors]):0
          "IT & Admin Labor/Data CenterColor": "#F16521",
          "Recurring Software Redundancy Fees": this.state.doors===0? 0: Math.round(RecSoftRedFee),
          "Recurring Software Redundancy FeesColor": "#7AC142",
        },  
        {
          "type": "Brivo RC",
          "Subscription fees": Math.round(this.props.appData.defaultData.Recurring.Subscription.Cloud[this.state.doors]),
          "Subscription feesColor": "#739CD2",
          "License & other fees": 0,
          "IT & Admin Labor/Data Center":0,
          "Recurring Software Redundancy Fees":0,
        
        }

     
      ]
    }

       
        keys={[
          "Hardware Software Install",
          "Brivo Hardware Software Install",
          "Doors+ Hardware Installation",
          "Redundancy option",
          "Subscription fees",
          "License & other fees",
          "IT & Admin Labor/Data Center",
          "Recurring Software Redundancy Fees"
        ]}
        indexBy="type"
        margin={{
            "top": 50,
            "right": 50,
            "bottom": 50,
            "left": 65
        }}
        motionDamping={15}

        enableLabel={false}
        isInteractive={false}
        padding={.2}
        innerPadding={1}
        colors={["#F16521","#739CD2","#737173","#F16521"]}
        colorBy={function(e){var t=e.id;return e.data[t+"Color"]}}
        format= {"$,.2r"}
        tooltipFormat={"$,"}
        borderColor="inherit:darker(1.6)"
        axisBottom={{
            "orient": "bottom",
            "tickSize": 0,
            "tickPadding": 12,
            "tickRotation": 0,
            "legend": "type",
            "legendPosition": "center",
            "legendOffset": 36
        }}
        axisLeft={{
            "orient": "left",
            "tickSize": 0,
            "tickPadding": 3,
            "tickRotation": 0,
            "legend": "costs",
            "legendPosition": "center",
            "legendOffset": -70,
            "format" : "$,.2r"
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor="inherit:darker(1.6)"
        animate={true}
        motionStiffness={90}
        
    />
    </div>
    <div className="legendHolder row">
    <div className="col-2 legpad"></div>
       <div className="col-5">
        <div className="col-12 legendTitle">NRC</div>
         <div className="col-12"> 
            <div className="legendOrange"></div>
            <div className="legendTitle">HW/SW, install</div>
          </div>
          <div className="col-12"> 
        <div className="legendDKGray"></div>
        <div className="legendTitle">Doors+ HW, Install</div> 
      </div>
      <div className="col-12"> 
        <div className="legendGray"></div>
        <div className="legendTitle">Redundancy option</div> 
      </div>
      <div className="col-12"> 
        <div className="legendBlue"></div>
        <div className="legendTitle">HW/SW, Install</div> 
      </div>
      </div>
      
  <div className="col-5">
      <div className="col-12 legendTitle">Ann. RC</div>
      <div className="col-12"> 
        <div className="legendOrange"></div>
        <div className="legendTitle">IT & Admin Labor/DC</div>
      </div>
      <div className="col-12"> 
        <div className="legendGreen"></div>
        <div className="legendTitle">License & other fees</div> 
      </div>
       <div className="col-12"> 
        <div className="legendBlue"></div>
        <div className="legendTitle">Sub fees</div> 
      </div>
      </div>
    </div></div>}


          {this.state.recuringChart&&<React.Fragment>
<h6 className="charttitle">On-Prem vs. Brivo Cloud</h6>

            
     <div className='chartContainer'>
      { this.state.doors? <div className='lowertco'>{Math.round(((tcoOnPrem - tcoBrivo)/tcoOnPrem)*100)}% Lower TCO </div> : <div className='lowertco'>-- TCO Savings</div> }
         <div className='barChart'>
           <ResponsiveLine
           data={[
            {
              "id": "On-Prem",
              "color": "#7AC142",
              "data": [

                {
                  "x": "1",
                  "y": Math.round(ITOnSite) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "2",
                  "y": Math.round(RecSoftRedFee+RecSoftFeeSite+(ITOnSite*2)) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "3",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*2+(ITOnSite*3)) +  NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "4",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*3+(ITOnSite*4)) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "5",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*4+(ITOnSite*5)) +  NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                }
               
              ]
            },
            {
              "id": "Brivo Cloud",
              "color": "#739CD2",
              "data": [
                {
                  "x": "1",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable
                },
                {
                  "x": "2",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*2
                },
                {
                  "x": "3",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*3
                },
                {
                  "x": "4",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*4
                },
                {
                  "x": "5",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*5
                }
              ]
            }
           
          ]
      }
           margin={{
               "top": 50,
               "right": 50,
               "bottom": 50,
               "left": 60
           }}
           xScale={{
               "type": "point"
           }}
           yScale={{
               "type": "linear",
               "min": "auto",
               "max": "auto"
           }}
           minY="auto"
           maxY="auto"
           axisBottom={{
               "orient": "bottom",
               "tickSize": 0,
               "tickPadding": 15,
               "tickRotation": 0,
               "legend": "Year",
               "legendOffset": 40,
               "legendPosition": "center"
           }}
           axisLeft={{
               "orient": "left",
               "tickSize": 0,
               "tickPadding": 3,
               "tickRotation": 0,
               "legend": "Cumulative TCO",
               "legendOffset": -70,
               "legendPosition": "center",
               "format" : "$,.2r"
           }}
            enableLabel={true}
            isInteractive={false}
           colorBy={function(e){return e.color}}
           dotSize={10}
           dotColor="inherit:darker(0.3)"
           dotBorderWidth={2}
           dotBorderColor="#ffffff"
           enableDotLabel={false}
           dotLabelFormat={"$,"}
           dotLabel="y"
           dotLabelYOffset={-12}
           animate={true}
           motionStiffness={90}
           motionDamping={15}
           enableGridX={false}
           lineWidth={4}
           tooltipFormat={"$,"}
           
           />




           </div>
      <div className="legendHolder row">
      <div className="col-2"> </div>
      <div className="col-4"> 
        <div className="legendGreen"></div>
        <div className="legendTitle">On-Prem costs</div>
      </div>
      <div className="col-4"> 
        <div className="legendBlue"></div>
        <div className="legendTitle"> Brivo Cloud costs</div> 
      </div>
      </div>
</div> </React.Fragment>
          }
           
{/*    Google Old example

  <Chart
            width={'600px'}
            height={'400px'}
            chartType="Line"
            loader={<div>Loading Chart</div>}
            data={[
                    [
                      'Year',
                      'On priem',
                      'Cloud',
                    ],
                    [1, this.state.costRecSoftFeeSite+this.state.costOnSiteIT, this.state.cloudCostVariable],
                    [2, this.state.costRecSoftFeeSite*2+this.state.costOnSiteIT*2, this.state.cloudCostVariable*2],
                    [3, this.state.costRecSoftFeeSite*3+this.state.costOnSiteIT*3, this.state.cloudCostVariable*3],
 
            ]}
            options={{
              chart: {
              title: '',
              subtitle: '',
              },
            }}
            rootProps={{ 'data-testid': '3' }}
          />}

CREATE HOLDER FOR GRAPHS to be converted SVGtoPNG
          */

        }
  <div id="pdfbarholder barChart" className="pdfbarholderclass">
<ResponsiveBar 

        data={[

          {

          "type": "On-Prem NRC",
          "Hardware Software Install": NRCtotalSite-HardwareInstall,
          "Hardware Software InstallColor": "#F16521",
          "Doors+ Hardware Installation":HardwareInstall,
          "Doors+ Hardware InstallationColor": "#999999",
          "Redundancy option":Math.round(this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0),
          "Redundancy optionColor": "#BFBFBF"

        },
        {
          "type": "Brivo NRC",
          "Brivo Hardware Software Install": Math.round(this.state.doors?this.props.appData.defaultData.Fixed['NRC'].Cloud[this.state.doors]:0),
          "Brivo Hardware Software InstallColor": "#739CD2",
          "Doors+ Hardware Installation": HardwareInstall,
          "Doors+ Hardware InstallationColor": "#999999"
       
        },
        {
          "type": "On-Prem RC",
          "Subscription fees": 0,
          "License & other fees": Math.round(RecSoftFeeSite),
          "License & other feesColor": "#7AC142",
          "IT & Admin Labor/Data Center": Math.round(ITOnSite), //this.state.redundant?(this.props.appData.defaultData.Recurring['Recuring Redundancy Server Outage Restoration'].Site.Redunednt[this.state.doors]):0
          "IT & Admin Labor/Data CenterColor": "#F16521",
          "Recurring Software Redundancy Fees": Math.round(RecSoftRedFee),
          "Recurring Software Redundancy FeesColor": "#7AC142",
        },  
        {
          "type": "Brivo RC",
          "Subscription fees": Math.round(this.props.appData.defaultData.Recurring.Subscription.Cloud[this.state.doors]),
          "Subscription feesColor": "#739CD2",
          "License & other fees": 0,
          "IT & Admin Labor/Data Center":0,
          "Recurring Software Redundancy Fees":0,
        
        }

     
      ]
    }

       
        keys={[
          "Hardware Software Install",
          "Brivo Hardware Software Install",
          "Doors+ Hardware Installation",
          "Redundancy option",
          "Subscription fees",
          "License & other fees",
          "IT & Admin Labor/Data Center",
          "Recurring Software Redundancy Fees"
        ]}
        indexBy="type"
        margin={{
            "top": 50,
            "right": 50,
            "bottom": 50,
            "left": 60
        }}
        motionDamping={15}
        enableLabel={false}
        isInteractive={true}
        padding={.2}
        innerPadding={1}
        colors={["#F16521","#739CD2","#737173","#F16521"]}
        colorBy={function(e){var t=e.id;return e.data[t+"Color"]}}
        format= {"$,.2r"}
        tooltipFormat={"$,"}
        borderColor="inherit:darker(1.6)"
        axisBottom={{
            "orient": "bottom",
            "tickSize": 0,
            "tickPadding": 12,
            "tickRotation": 0,
            "legend": "Type",
            "legendPosition": "center",
            "legendOffset": 36
        }}
        axisLeft={{
            "orient": "left",
            "tickSize": 0,
            "tickPadding": 3,
            "tickRotation": 0,
            "legend": "COSTS",
            "legendPosition": "center",
            "legendOffset": -15,
            "tickValues" : []
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor="inherit:darker(1.6)"
        animate={false}
        motionStiffness={90}
        
    /> 

 <ResponsiveLine
           data={[
            {
              "id": "On-Prem",
              "color": "#7AC142",
              "data": [

                {
                  "x": "1",
                  "y": Math.round(ITOnSite) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "2",
                  "y": Math.round(RecSoftRedFee+RecSoftFeeSite+(ITOnSite*2)) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "3",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*2+(ITOnSite*3)) +  NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "4",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*3+(ITOnSite*4)) + NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                },
                {
                  "x": "5",
                  "y": Math.round((RecSoftRedFee+RecSoftFeeSite)*4+(ITOnSite*5)) +  NRCtotalSite + (this.state.redundant?this.props.appData.defaultData.Fixed['Redundancy'].Site[this.state.doors]:0)
                }
               
              ]
            },
            {
              "id": "Brivo Cloud",
              "color": "#739CD2",
              "data": [
                {
                  "x": "1",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable
                },
                {
                  "x": "2",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*2
                },
                {
                  "x": "3",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*3
                },
                {
                  "x": "4",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*4
                },
                {
                  "x": "5",
                  "y": this.state.cloudCostFixed+this.state.cloudCostVariable*5
                }
              ]
            }
           
          ]
      }
           margin={{
               "top": 50,
               "right": 50,
               "bottom": 50,
               "left": 60
           }}
           xScale={{
               "type": "point"
           }}
           yScale={{
               "type": "linear",
               "min": "auto",
               "max": "auto"
           }}
           minY="auto"
           maxY="auto"
           axisBottom={{
               "orient": "bottom",
               "tickSize": 0,
               "tickPadding": 15,
               "tickRotation": 0,
               "legend": "Year",
               "legendOffset": 40,
               "legendPosition": "center"
           }}
           axisLeft={{
               "orient": "left",
               "tickSize": 0,
               "tickPadding": 3,
               "tickRotation": 0,
               "legend": "CUMULATIVE TCO",
               "legendPosition": "center",
               "legendOffset": -15,
                "tickValues" : []
           }}
            enableLabel={false}
            isInteractive={false}
           colorBy={function(e){return e.color}}
           dotSize={10}
           dotColor="inherit:darker(0.3)"
           dotBorderWidth={2}
           dotBorderColor="#ffffff"
           enableDotLabel={false}
           dotLabelFormat={"$,"}
           dotLabel="y"
           dotLabelYOffset={-12}
           animate={false}
           motionStiffness={90}
           motionDamping={15}
           enableGridX={false}
           lineWidth={4}
           tooltipFormat={"$,"}
           
           />

    </div>
          {this.state.doors!==0&& <button id="pdfbutton" onClick={(e) =>{
              this.setState({barString:''})
              this.setState({lineString:''})
              this.getLine()
              this.getBar()
              window.sendevent('PDF Button APP','click','');
              this.setState({pdf:true})
            }}>PDF Download</button>}
        </div>  
      </div>    
    </div>
          <div className="row disclaimFooter">
          <div className="col-md-5 col-sm-10 discy">  
             {this.state.selectedRow==="OnPrem"&&<div className="footNote">*Source: 2018 Benchmarks, Trends and Best Practices survey, Security Management Magazine)</div>}
  
              <p id="disclaimer" className="small">All costs and savings claims based on industry averages as featured in <i>Why it’s Time to Upgrade Your On-Premise Physical Security System</i>, Brivo, 2018, and will vary. Prices and savings claim for demonstration purposes only and do not constitute offers from Brivo. Contact your Brivo sales partner for a detailed price quote.</p>
       
        </div>
     </div>
          <main>
         
        </main>
      </div>
  </form>

  );
}
}

 
export default App;


// WEBPACK FOOTER //
// ./src/App.js